import { connect } from 'react-redux'
import { sagaActions } from '../../../sagas'
import layoutNameSelector from './layoutNameSelector'
import LayoutName from './LayoutName'

export default connect(
  layoutNameSelector,
  {
    requestChangeLayoutName: sagaActions.requestChangeLayoutName,
  }
)(LayoutName)
